export const useGA4Events = () => true;
